<script setup>
const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  refine: {
    type: Function,
    required: true,
  },
})
</script>

<template>
  <div @click.prevent="refine(item.value)" class="flex items-center text-base sm:text-sm cursor-pointer p-1 hover:bg-gray-100">
    <input :value="item.value" :checked="item.isRefined" disabled type="checkbox" class="flex-shrink-0 h-4 w-4 border-gray-300 rounded text-indigo-600 focus:ring-indigo-500 pointer-events-none">
    <div class="flex items-center justify-between w-full">
      <div class="ml-2 capitalize min-w-0 flex-1 text-gray-600">{{ item.label }}</div>
      <div class="ml-2 capitalize min-w-0 text-gray-600 text-right rounded-lg bg-gray-100 px-2">{{ item.count.toLocaleString() }}</div>
    </div>
  </div>
</template>

